<template>
    
    <div>
        <cabecalho titulo="Redes"/>
        <div class="container-fluid mb-4">

            <h2>Laços Orientador Orientando Terceiros</h2>
            <img style="width: 100%" src="redes/Laços Orientador Orientando Terceiros.png" alt="Laços Orientador Orientando Terceiros">

        </div>
    </div>
</template>

<script>
import Cabecalho from '@/components/Cabecalho';
export default {
    name: 'Redes',
    components: {Cabecalho}
}
</script>
